import React from 'react';
import { observable } from "mobx";
import AgendamentoContainerService from "../../../../services/AgendamentoContainerService";
import moment from "moment";
import { formatarDataCustomHTML, statusNotaFormatter } from '../../../../utils/formatar';
import { buscaSemResultado } from '../../../../utils/mensagens';
import lscache from "lscache";
import { sortCaret } from '../../../comum/components/Icones';

export default class AgendamentoNotaFiscalStore {

    @observable notasFiscaisLista;
    @observable loading;
    @observable modalConfirm;
    @observable responseAcao;

    /** Paginação */
    @observable total;

    /** Filtro */
    @observable filtroSelecionado;
    @observable dataEmissaoInicio;
    @observable dataEmissaoFim;

    /** Select */
    @observable status;
    @observable statusPreenchido;

    @observable idSelecionado;
    @observable tableMessage;

    @observable importarXML;
    @observable erroImportXML;
    @observable erroImportXMLMensagem;
    @observable validandoXML;

    // Adicionar por modais
    @observable mostrarModalXml;
    @observable inserindoEmModal;
    @observable excluindoNotas;
    @observable jsonFile;

    constructor() {
        this.notasFiscaisLista = [];
        this.loading = false;
        this.modalConfirm = false;
        this.idSelecionado = false;
        this.responseAcao = false;
        this.mensagemSucesso = "Nota Fiscal Excluída Com Sucesso.";
        this.mensagemErro = "Não Foi Possível Excluir Esta Nota.";

        /** Select Options */
        this.status = [{Id: 'A', DscStatus: 'Associada'},{Id: 'B', DscStatus: 'Embarcada'}, {Id: 'P', DscStatus: 'Pendente'}, {id: 'S', DscStatus: 'Saída Gate'}];

        /** Campos Selecionados */
        this.statusPreenchido = '';
        this.dataEmissaoInicioPreenchido = moment().startOf('month').format("YYYY-MM-DD");
        this.dataEmissaoFimPreenchido = moment().add(1, 'day').format("YYYY-MM-DD");

        /** Paginação */
        this.total = null;

        this.filtrado = false;
        this.excluindoNotas = false;
        this.filtroSelecionado = [];
        this.tamanhoPagina = 100;

        this.importarXML = false;
        this.erroImportXML = false;
        this.erroImportXMLMensagem = "";
        this.mostrarModalXml = false;
        this.xmlFileData = "";
        this.validandoXML = false;
        this.jsonFile = null;
        this.fileXMLType = '';

        /** Colunas da Tabela */
        this.todasColunas = [{
            dataField: 'NumNotaTransp',
            text: 'N. Nota',
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'SerieNotaTransp',
            text: 'Série',
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'DatEmissao',
            text: 'Dt. Emissão',
            formatter: formatarDataCustomHTML,
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'CnpjDest',
            text: 'CNPJ Dest.',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'RazaoSocialDest',
            text: 'R. Social Dest',
            sort: true,
            sortCaret: sortCaret,
        },{
            dataField: 'ValTotal',
            text: 'Valor Total',
            sort: true,
            sortCaret: sortCaret,
        }, {
            dataField: 'Status',
            text: 'Situação',
            formatter: statusNotaFormatter,
            sort: true,
            sortCaret: sortCaret,
        }];

        this.colunas = this.todasColunas;

        /** Serviços de Agendamento */
        this.agendamentoService = new AgendamentoContainerService();

        this.tableMessage = "";
    };

    carregarLista() {

      if(this.validacaoFiltrosNota()) {
          this.filtrado = true;
          this.loading = true;
          this.notasFiscaisLista = [];

          this.filtroSelecionado["dataEmissaoInicio"] = this.dataEmissaoInicioPreenchido;
          this.filtroSelecionado["dataEmissaoFim"] = this.dataEmissaoFimPreenchido;
          
          this.agendamentoService.listarNotas(this.filtroSelecionado)
                .then(response => {
                    this.notasFiscaisLista = response ? response.data : [];
                    this.total = this.notasFiscaisLista.length;
                    if (this.notasFiscaisLista.length === 0) {
                        this.tableMessage = buscaSemResultado
                    } else {
                        this.tableMessage = ''
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(() => this.loading = false );
       }
    };

    cancelarNota(){
        this.excluindoNotas = true;
        const loadingPromises = Promise.all([
            this.agendamentoService.excluirNotaFiscal({notaFiscalTranspId: this.idSelecionado}).then(response => {
                if(response){
                    if(response.data.Sucesso){
                        this.responseAcao = this.mensagemSucesso;
                        this.carregarLista();
                    }else{
                        this.responseAcao = response.data.Mensagem;
                    }
                }else{
                    this.responseAcao = this.mensagemErro;
                }
            }).catch(error => {
                this.responseAcao = this.mensagemErro;
            }),
        ]);
        loadingPromises.then(() => { this.excluindoNotas = false }).catch((error) => { });
    }

    onChangeDataInicio = (data) => {
        this.dataEmissaoInicioPreenchido = data;
    };

    onChangeDataFim = (data) => {
        this.dataEmissaoFimPreenchido = data;
    };

    setFiltroSelecionado(campo, valor){
        this.filtroSelecionado[campo] = valor;
    };

    setStatus = (valor) => {
        this.statusPreenchido = valor ? valor : "";
        this.filtroSelecionado['status'] = valor? valor.value: "";
    };

    setIdRow(id){
        this.modalConfirm = true;
        this.idSelecionado = id ? id : false;
    };

    setModalConfirm(){
        this.modalConfirm = !this.modalConfirm;
        if(!this.modalConfirm){
            this.idSelecionado = false;
            this.responseAcao = false;
        }
    };

    validacaoFiltrosNota = () => {
        return this.dataEmissaoInicioPreenchido && this.dataEmissaoFimPreenchido
    };

    abrirInserirXMLNotaFiscal = (type) => {
        this.fileXMLType = type;
        this.mostrarModalXml = true;
    };

    adicionarXMLNotaFiscal = () => {
        this.fecharModais();
        this.importarXML = true
    };

    guardaXMLNotaFiscal = (event) => {
        let xmlFileReader = new FileReader();
        this.xmlFileData = event.target.files[0];
        xmlFileReader.readAsText(this.xmlFileData);
        
        xmlFileReader.onload = () => {
            this.validandoXML = true;
            let service;
            if(this.fileXMLType.includes('cte')) {
                service = this.agendamentoService.xmlImportNotaCTE;
            } else {
                service = this.agendamentoService.xmlImportNota;
            }
            service(xmlFileReader.result)
            .then(response => {
                if(response && response.data.Sucesso){
                    this.jsonFile = {};
                    this.jsonFile = response.data.Nf;
                    this.jsonFile.ListaCntr = response.data.ListaCntr;
                    this.jsonFile.ListaItem = response.data.ListaItem;
                    this.erroImportXML = false;
                } else {
                    this.setErroImportXML(response.data.Mensagem)
                }
            }).catch(err => { console.log(err); this.jsonFile = null; this.setErroImportXML("Falha ao carregar arquivo."); })
            .finally( () =>  this.validandoXML = false)
        }
    };

    fecharModais = () => {
        this.fileXMLType = '';
        this.mostrarModalXml = false;
    };

    setErroImportXML = (mensagem) => {
        this.erroImportXML = true;
        this.erroImportXMLMensagem = mensagem;
    };
}


// WEBPACK FOOTER //
// ./src/modules/agendamento/nota-fiscal-visualizar/stores/AgendamentoNotaFiscalStore.js